// Group elhelyezése egy shiften belül: a group teljes egészében a shift idején belül
// kell legyen, a shift határán nem lóghat át.

export const SHIFT_SNAP_MINUTES = 5;

export function shiftWindow(shift) {
  const start = new Date(shift.date).getTime();
  return { start, end: start + (shift.estimated_minutes || 480) * 60000 };
}

// A kért kezdés 5 percre kerekítve; null, ha a group így nem férne el a shiftben.
export function placeInShift(shift, startMs, durationMinutes) {
  const { start, end } = shiftWindow(shift);
  const snap = SHIFT_SNAP_MINUTES * 60000;
  const snapped = start + Math.round((startMs - start) / snap) * snap;
  const duration = (durationMinutes || 60) * 60000;
  if (snapped < start || snapped + duration > end) return null;
  return snapped;
}

// Egy shifthez kötött group legfeljebb a shift végéig tarthat.
export function maxMinutesInShift(shift, event) {
  const { end } = shiftWindow(shift);
  return Math.max(15, Math.floor((end - new Date(event.date).getTime()) / 60000));
}

// A shift nem lehet rövidebb, mint ameddig a benne lévő groupok tartanak.
export function minShiftMinutes(shift, events) {
  const { start } = shiftWindow(shift);
  const shiftPlanId = String(shift.id).replace("plan-", "");
  return events
    .filter(ev => !ev.is_shift && ev.shift_plan_id != null && String(ev.shift_plan_id) === shiftPlanId)
    .reduce((min, ev) => {
      const end = new Date(ev.date).getTime() + (ev.estimated_minutes || 60) * 60000;
      return Math.max(min, Math.ceil((end - start) / 60000));
    }, 15);
}
